import { render, staticRenderFns } from "./u-badge.vue?vue&type=template&id=662d25bf&scoped=true&"
import script from "./u-badge.vue?vue&type=script&lang=js&"
export * from "./u-badge.vue?vue&type=script&lang=js&"
import style0 from "./u-badge.vue?vue&type=style&index=0&id=662d25bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d25bf",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-badge/u-badge.vue"
export default component.exports